import type { CSSProperties } from "react";

/** 主按钮（type=primary）视觉样式 */
export interface UserHoldingsPrimaryButtonStyle {
  /** 背景色 */
  backgroundColor: string;
  /** 圆角（px） */
  borderRadius: number;
  /** 字重 */
  fontWeight: number;
}

/** 持仓复盘各页主按钮样式配置 */
export const USER_HOLDINGS_PRIMARY_BUTTON_STYLE: UserHoldingsPrimaryButtonStyle = {
  backgroundColor: " #ff85c0",
  borderRadius: 5,
  fontWeight: 400,
};

/** 供页面根节点注入 CSS 变量，驱动主按钮与直角弹窗按钮圆角/背景 */
export function userHoldingsPageCssVars(): CSSProperties {
  const { backgroundColor, borderRadius, fontWeight } = USER_HOLDINGS_PRIMARY_BUTTON_STYLE;
  return {
    ["--uh-primary-btn-bg" as string]: backgroundColor,
    ["--uh-primary-btn-radius" as string]: `${borderRadius}px`,
    ["--uh-primary-btn-font-weight" as string]: String(fontWeight),
  };
}
